import { trpc } from '@tencent/tpro_rmonitor_product_manager_product_permissions';
import AbstractHttpClient from '@/infrastructure/axios/request';
import { WithTypeCast } from '@raft/utils';
import { TrpcService } from './trpc';

export type IGetProductPermissionsRsp = WithTypeCast<trpc.rmonitor.product_manager.IGetProductPermissionsRsp>;
export type IProductType = WithTypeCast<trpc.rmonitor.product_manager.ProductType>;
export const { ProductType } = trpc.rmonitor.product_manager;

export class ProductPermissionsService extends AbstractHttpClient {
  constructor() {
    super({
      serviceName: TrpcService.ProductPermission,
    });
  }

  /**
   * 获取产品权限
   */
  public async getProductPermissions(): Promise<IGetProductPermissionsRsp> {
    try {
      return  await this.trpcPost<IGetProductPermissionsRsp>('GetProductPermissions', {});
    } catch (e) {
      return {};
    }
  }
}


export const productPermissionsService = new ProductPermissionsService();
